import React from 'react';
import { Modal } from '../_components';

import { useModal } from '../_contexts';

import { ConfirmDeletionForm } from './forms';

export function DeleteConfirmationModal(props) {
  const { type, item, prevModal, text } = props;
  const { closeModal } = useModal();
  return (
    <Modal
      id="deleteConfirmationModal"
      // backdrop
      title="Confirm Deletion"
      icon="fas fa-exclamation-triangle"
      size="xs"
      open={true}
      onClose={() => closeModal()}
    >
      <ConfirmDeletionForm
        type={type}
        item={item}
        prev={prevModal}
        text={text}
      />
    </Modal>
  );
}
